module.exports = __webpack_public_path__ + "img/ocean.be5030ca.webp";